export function isDatetimeType(type) {
  return type === "datetime" || type?.startsWith("tzdatetime");
}

export function isNumberType(type) {
  return type === "integer" || type === "float";
}
